import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { getResetByTag, utilityStyles } from '../../styles';
import StyledHorizontalListItem from './styles/horizontal-list.item.styles';
var _ref4 = process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "1s3v7gx-defaultStyles",
  styles: "display:flex;label:defaultStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var defaultStyles = function defaultStyles(_ref5) {
  var flex = _ref5.flex;
  if (!flex) return;
  return _ref4;
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1azakc",
  styles: "text-align:center"
} : {
  name: "lxnryw-alignmentStyles",
  styles: "text-align:center;label:alignmentStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "2qga7i",
  styles: "text-align:right"
} : {
  name: "1abbagr-alignmentStyles",
  styles: "text-align:right;label:alignmentStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : {
  name: "4bbwwy-alignmentStyles",
  styles: "text-align:left;label:alignmentStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var alignmentStyles = function alignmentStyles(_ref6) {
  var align = _ref6.align;
  switch (align) {
    case 'left':
      return _ref3;
    case 'right':
      return _ref2;
    case 'center':
      return _ref;
    case 'middle':
      return /*#__PURE__*/css(StyledHorizontalListItem, "{vertical-align:middle;}" + (process.env.NODE_ENV === "production" ? "" : ";label:alignmentStyles;"));
    case 'bottom':
      return /*#__PURE__*/css(StyledHorizontalListItem, "{vertical-align:text-bottom;}" + (process.env.NODE_ENV === "production" ? "" : ";label:alignmentStyles;"));
  }
};
var resetStyles = getResetByTag('ul');
var StyledHorizontalList = /*#__PURE__*/_styled('ul', process.env.NODE_ENV === "production" ? {
  target: "ezahn2e0"
} : {
  target: "ezahn2e0",
  label: "StyledHorizontalList"
})(resetStyles, defaultStyles, alignmentStyles, utilityStyles);
export default StyledHorizontalList;